import { IOPanel } from './IOPanel/IOPanel';
import React, { useState } from 'react';
import c from './RTTaskIO.module.css';
import GeneratedObject from '../GeneratedObject'
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import { OpenSocketPanel } from './OpenSocketPanel/OpenSocketPanel';
import { sendStartSignal } from './utils/api'
import 'highlight.js/styles/atom-one-light.css'; // Example style, you can choose others

export const RTTaskIO = ({
    rtTaskData,
    dtTaskData,
}) => {

    const [rtTask, setRtTask] = useState(rtTaskData);
    const [dtTask, setDtTask] = useState(dtTaskData);
    const [openInputSocketId, setOpenInputSocketId] = useState(null)
    const [openOutputSocketId, setOpenOutputSocketId] = useState(null)

    const [hoveredProcessId, setHoveredProcessId] = useState(null);

    let gridDisplayClass = null;
    if (openInputSocketId && openOutputSocketId) {
        gridDisplayClass = "in-out-displayed"
    } else {
        if (openInputSocketId) {
            gridDisplayClass = "input-displayed"
        }
        if (openOutputSocketId) {
            gridDisplayClass = "output-displayed"
        }
    }

    const handleOpenInputObject = (inputId) => {
        if (openInputSocketId === inputId) {
            setOpenInputSocketId(null)
        } else {
            setOpenInputSocketId(inputId)
        }
    }

    const handleOpenOutputObject = (outputId) => {
        if (openOutputSocketId === outputId) {
            setOpenOutputSocketId(null)
        } else {
            setOpenOutputSocketId(outputId)
        }
    }


    const handleAddRtProcessAndSockets = (newRtProcess, newRtSockets) => {
        // add rtProcess to rtProcesses
        // add rtSockets to rtSockets
        let newRtTask = { ...rtTask }
        newRtTask.processes = [...newRtTask.processes, newRtProcess]
        newRtTask.sockets = [...newRtTask.sockets, ...newRtSockets]
        setRtTask(newRtTask)
    }

    const handleAddRtSockets = (newRtSockets) => {
        // add rtSockets to rtSockets
        let newRtTask = { ...rtTask }
        newRtTask.sockets = [...newRtTask.sockets, ...newRtSockets]
        // remove duplicates
        newRtTask.sockets = newRtTask.sockets.filter((socket, index, self) =>
            index === self.findIndex((t) => (
                t.id === socket.id
            ))
        )
        setRtTask(newRtTask)
    }

    const handleSocketIsFinalized = (socketId) => {
        // find the socket in rtTask and set isFinal to true
        let newRtTask = { ...rtTask }
        let newRtSockets = newRtTask.sockets.map(socket => {
            if (socket.id === socketId) {
                socket.isFinal = true
            }
            return socket
        })
        newRtTask.sockets = newRtSockets
        setRtTask(newRtTask)
    }

    const setRtTaskStartSignalReceivedTimestamp = (startSignalReceivedTimestamp) => {
        let newRtTask = { ...rtTask }
        newRtTask.startSignalReceivedTimestamp = startSignalReceivedTimestamp
        setRtTask(newRtTask)
    }

    const handleStartRtTaskBtnClick = () => {
        sendStartSignal(rtTask.id)
        .then(response => {
            if (response.error) {
                console.error(response.error)
                alert(response.error)
                return
            }
            setRtTaskStartSignalReceivedTimestamp(new Date().toISOString()) // TODO: Better to get it from the API,  but it doesn't give it as a response yet
        })
        .catch(error => { 
            console.error(error)
            alert(error)
        })  
    }


    return (
        <div className={`${c["ctr"]} ${c[gridDisplayClass]}`}>
            <div className={c["header"]}>
                <h1 className={c["rt-task-name"]}>{rtTask.name}</h1>
            </div>
            
            <IOPanel
                className={c["io-panel-input"]}
                rtTaskId={rtTask.id}
                dtProcesses={dtTask.processes}
                dtSockets={dtTask.sockets}
                rtProcesses={rtTask.processes}
                rtSockets={rtTask.sockets}
                hoveredProcessId={hoveredProcessId}
                setHoveredProcessId={setHoveredProcessId}
                openSocketId={openInputSocketId}
                setOpenSocketId={handleOpenInputObject}
                onSocketFinalized={handleSocketIsFinalized}
                onRtProcessAndSocketsAdd={handleAddRtProcessAndSockets}
                onRtSocketsAdd={handleAddRtSockets}
            />
            {openInputSocketId ? <div>
                <OpenSocketPanel
                    rtTask={rtTask}
                    dtTask={dtTask}
                    setRtTaskData={setRtTask}
                    rtSocketId={openInputSocketId}
                />
            </div> : ""}

            <div className={c["mid-body"]}>
                <div className={c["task-name-ctr"]}>
                    <div className={c['markdown-ctr']}>
                        <Markdown
                            rehypePlugins={[rehypeHighlight]}
                            remarkPlugins={[remarkGfm]}
                        >
                            {dtTask.markdownDescription ? dtTask.markdownDescription : dtTask.description}
                        </Markdown>
                    </div>
                </div>

            </div>
            {openOutputSocketId ? <div>
                <OpenSocketPanel
                    rtTask={rtTask}
                    dtTask={dtTask}
                    setRtTaskData={setRtTask}
                    rtSocketId={openOutputSocketId}
                />
            </div> : ""}
            <IOPanel 
                className={c["io-panel-output"]}
                rtTaskId={rtTask.id}
                output
                dtProcesses={dtTask.processes}
                dtSockets={dtTask.sockets}
                rtProcesses={rtTask.processes}
                rtSockets={rtTask.sockets}
                hoveredProcessId={hoveredProcessId}
                setHoveredProcessId={setHoveredProcessId}
                openSocketId={openOutputSocketId}
                setOpenSocketId={handleOpenOutputObject}
                onSocketFinalized={handleSocketIsFinalized}
                onRtProcessAndSocketsAdd={handleAddRtProcessAndSockets}
                onRtSocketsAdd={handleAddRtSockets}
            />
            <div className={c["footer"]}>
                {rtTask.startSignalReceivedTimestamp ? <p>Start signal sent/Task does not need start signal</p>:
                    <button className={c["start-task-btn"]} onClick={handleStartRtTaskBtnClick}>START</button>
                }
            </div>
        </div>
    )
}
